import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FullTemplate } from '@app/modules/direct/services/direct.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';

@Component({
  selector: 'sbnb-direct-template-light',
  templateUrl: './direct-template-light.component.html',
  styleUrls: ['./direct-template-light.component.scss'],
})
export class DirectTemplateLightComponent {
  @Input() template: FullTemplate;
  @Input() isSelected = false;
  @Output() selectTemplate = new EventEmitter<void>();

  isMobile$ = this.deviceDetectionService.isMobileViewport();

  constructor(private deviceDetectionService: DeviceDetectionService) {}
}
